import React, { Component } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

class ConfirmDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: true,
        };
    }

    handleClickOpen = () => {
        this.setState({open: true});
    }

    handleClose = () => this.props.onClose();
    handleOk = () => this.props.onConfirm(true);

    render() {
        //const { open } = this.state;
        const { open } = this.props;
        return (
            <div>
                <Dialog
                    open={open}
                    onClose={this.handleClose}
                    scroll={"paper"}
                    TransitionComponent={Transition}
                    keepMounted
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    className="confirm-dialog"
                >
                    <button onClick={this.handleClose} className="btn btn-close"></button>
                    <DialogTitle id="alert-dialog-title">{"Use Google's location service?"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Are you sure you want to delete this Product?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <button onClick={this.handleOk} className="btn btn-info">
                            Yes
                        </button>
                        <button onClick={this.handleClose} className="btn btn-secondary">
                            No
                        </button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

export default ConfirmDialog;